import { DEFAULT_DEFINITION, combineTimelineEntryDefinitionSourceValues, } from '@corti/lib/coreApiService';
export function resolveDefinition(def) {
    var _a, _b;
    return Object.assign(Object.assign({}, def), { id: combineTimelineEntryDefinitionSourceValues(def.source), title: def.title.trim(), text: (_a = def.text) === null || _a === void 0 ? void 0 : _a.trim(), hint: (_b = def.hint) === null || _b === void 0 ? void 0 : _b.trim(), style: {
            color: def.style.color ? def.style.color : DEFAULT_DEFINITION.style.color,
        } });
}
